module.exports = __webpack_public_path__ + "fonts/enterprisePortal.7fbe59b.ttf";